import { RFP_OFFER_MEMBER_TYPE_COMPANY, RFP_QUESTION_QUESTION_TARGET_CLIENT, } from '../rfp';
/**
 * 案件の共有・提案メンバーのフォーム初期値
 * @param role
 * @returns {boolean}
 */
export const RFP_OFFER_FORM_MEMBER_INITIAL_VALUES = {
    memberType: RFP_OFFER_MEMBER_TYPE_COMPANY.value,
};
/**
 * 提案ページの請求書送付先初期値
 * @param role
 * @returns {boolean}
 */
export const RFP_OFFER_FORM_PAYMENT_BILLING_INFORMATION_INITIAL_VALUES = {
    email: '',
    firstName: '',
    lastName: '',
};
/**
 * 案件質問ページのフォーム初期値
 * @param role
 * @returns {boolean}
 */
export const RFP_ONLINE_QUESTION_INITIAL_VALUES = {
    onlineQuestions: [
        {
            question: null,
            questionTarget: RFP_QUESTION_QUESTION_TARGET_CLIENT.value.toString(),
        },
    ],
};
